// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file yatayat/booking/v1/booking.proto (package yatayat.booking.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_yatayat_auth_v1_access } from "../../auth/v1/access_pb";
import type { PlaceRef } from "../../network/v1/network_pb";
import { file_yatayat_network_v1_network } from "../../network/v1/network_pb";
import type { LocalizedName, Money, VehicleClass } from "../../types/v1/types_pb";
import { file_yatayat_types_v1_types } from "../../types/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yatayat/booking/v1/booking.proto.
 */
export const file_yatayat_booking_v1_booking: GenFile = /*@__PURE__*/
  fileDesc("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", [file_yatayat_auth_v1_access, file_yatayat_network_v1_network, file_yatayat_types_v1_types]);

/**
 * TripOffer is a trip as offered for one stretch.
 *
 * @generated from message yatayat.booking.v1.TripOffer
 */
export type TripOffer = Message<"yatayat.booking.v1.TripOffer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string route_code = 2;
   */
  routeCode: string;

  /**
   * @generated from field: yatayat.types.v1.LocalizedName route_name = 3;
   */
  routeName?: LocalizedName | undefined;

  /**
   * @generated from field: yatayat.types.v1.LocalizedName operator_name = 4;
   */
  operatorName?: LocalizedName | undefined;

  /**
   * @generated from field: yatayat.types.v1.VehicleClass vehicle_class = 5;
   */
  vehicleClass: VehicleClass;

  /**
   * @generated from field: bool electric = 6;
   */
  electric: boolean;

  /**
   * Departure from the route's origin.
   *
   * @generated from field: int64 departs_at_ms = 7;
   */
  departsAtMs: bigint;

  /**
   * @generated from field: int32 seats_left = 8;
   */
  seatsLeft: number;

  /**
   * @generated from field: int32 seat_count = 9;
   */
  seatCount: number;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef from = 10;
   */
  from?: PlaceRef | undefined;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef to = 11;
   */
  to?: PlaceRef | undefined;

  /**
   * @generated from field: double distance_km = 12;
   */
  distanceKm: number;

  /**
   * @generated from field: yatayat.types.v1.Money official_fare = 13;
   */
  officialFare?: Money | undefined;

  /**
   * @generated from field: string fare_version_label = 14;
   */
  fareVersionLabel: string;

  /**
   * The vehicle's route permit is in force on the day of travel.
   *
   * @generated from field: bool permit_verified = 15;
   */
  permitVerified: boolean;
};

/**
 * Describes the message yatayat.booking.v1.TripOffer.
 * Use `create(TripOfferSchema)` to create a new message.
 */
export const TripOfferSchema: GenMessage<TripOffer> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 0);

/**
 * @generated from message yatayat.booking.v1.Seat
 */
export type Seat = Message<"yatayat.booking.v1.Seat"> & {
  /**
   * @generated from field: string no = 1;
   */
  no: string;

  /**
   * @generated from field: int32 row = 2;
   */
  row: number;

  /**
   * @generated from field: int32 col = 3;
   */
  col: number;

  /**
   * @generated from field: bool available = 4;
   */
  available: boolean;
};

/**
 * Describes the message yatayat.booking.v1.Seat.
 * Use `create(SeatSchema)` to create a new message.
 */
export const SeatSchema: GenMessage<Seat> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 1);

/**
 * @generated from message yatayat.booking.v1.CancellationQuote
 */
export type CancellationQuote = Message<"yatayat.booking.v1.CancellationQuote"> & {
  /**
   * @generated from field: int32 fee_percent = 1;
   */
  feePercent: number;

  /**
   * @generated from field: yatayat.types.v1.Money fee = 2;
   */
  fee?: Money | undefined;

  /**
   * @generated from field: yatayat.types.v1.Money refund = 3;
   */
  refund?: Money | undefined;
};

/**
 * Describes the message yatayat.booking.v1.CancellationQuote.
 * Use `create(CancellationQuoteSchema)` to create a new message.
 */
export const CancellationQuoteSchema: GenMessage<CancellationQuote> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 2);

/**
 * @generated from message yatayat.booking.v1.Ticket
 */
export type Ticket = Message<"yatayat.booking.v1.Ticket"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Short code passengers read out, e.g. "YT-7K3P9Q".
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: yatayat.booking.v1.TicketStatus status = 3;
   */
  status: TicketStatus;

  /**
   * @generated from field: yatayat.booking.v1.Channel channel = 4;
   */
  channel: Channel;

  /**
   * @generated from field: yatayat.booking.v1.TripOffer trip = 5;
   */
  trip?: TripOffer | undefined;

  /**
   * @generated from field: string seat_no = 6;
   */
  seatNo: string;

  /**
   * @generated from field: yatayat.types.v1.Money official_fare = 7;
   */
  officialFare?: Money | undefined;

  /**
   * @generated from field: yatayat.types.v1.Money charged_fare = 8;
   */
  chargedFare?: Money | undefined;

  /**
   * @generated from field: yatayat.booking.v1.PaymentMethod payment_method = 9;
   */
  paymentMethod: PaymentMethod;

  /**
   * @generated from field: int64 confirmed_at_ms = 10;
   */
  confirmedAtMs: bigint;

  /**
   * Signed payload to render as the ticket's QR code; empty unless confirmed.
   *
   * @generated from field: string qr_payload = 11;
   */
  qrPayload: string;

  /**
   * What cancelling now would cost; unset when the ticket can't be cancelled.
   *
   * @generated from field: yatayat.booking.v1.CancellationQuote cancellation_if_now = 12;
   */
  cancellationIfNow?: CancellationQuote | undefined;

  /**
   * Set once cancelled.
   *
   * @generated from field: yatayat.types.v1.Money cancellation_fee = 13;
   */
  cancellationFee?: Money | undefined;

  /**
   * @generated from field: yatayat.types.v1.Money refund = 14;
   */
  refund?: Money | undefined;

  /**
   * @generated from field: string passenger_phone_masked = 15;
   */
  passengerPhoneMasked: string;
};

/**
 * Describes the message yatayat.booking.v1.Ticket.
 * Use `create(TicketSchema)` to create a new message.
 */
export const TicketSchema: GenMessage<Ticket> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 3);

/**
 * @generated from message yatayat.booking.v1.SearchTripsRequest
 */
export type SearchTripsRequest = Message<"yatayat.booking.v1.SearchTripsRequest"> & {
  /**
   * @generated from field: string from_code = 1;
   */
  fromCode: string;

  /**
   * @generated from field: string to_code = 2;
   */
  toCode: string;

  /**
   * Nepal date of travel, YYYY-MM-DD.
   *
   * @generated from field: string date = 3;
   */
  date: string;
};

/**
 * Describes the message yatayat.booking.v1.SearchTripsRequest.
 * Use `create(SearchTripsRequestSchema)` to create a new message.
 */
export const SearchTripsRequestSchema: GenMessage<SearchTripsRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 4);

/**
 * @generated from message yatayat.booking.v1.SearchTripsResponse
 */
export type SearchTripsResponse = Message<"yatayat.booking.v1.SearchTripsResponse"> & {
  /**
   * @generated from field: repeated yatayat.booking.v1.TripOffer trips = 1;
   */
  trips: TripOffer[];
};

/**
 * Describes the message yatayat.booking.v1.SearchTripsResponse.
 * Use `create(SearchTripsResponseSchema)` to create a new message.
 */
export const SearchTripsResponseSchema: GenMessage<SearchTripsResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 5);

/**
 * @generated from message yatayat.booking.v1.GetSeatMapRequest
 */
export type GetSeatMapRequest = Message<"yatayat.booking.v1.GetSeatMapRequest"> & {
  /**
   * @generated from field: string trip_id = 1;
   */
  tripId: string;

  /**
   * @generated from field: string from_code = 2;
   */
  fromCode: string;

  /**
   * @generated from field: string to_code = 3;
   */
  toCode: string;
};

/**
 * Describes the message yatayat.booking.v1.GetSeatMapRequest.
 * Use `create(GetSeatMapRequestSchema)` to create a new message.
 */
export const GetSeatMapRequestSchema: GenMessage<GetSeatMapRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 6);

/**
 * @generated from message yatayat.booking.v1.GetSeatMapResponse
 */
export type GetSeatMapResponse = Message<"yatayat.booking.v1.GetSeatMapResponse"> & {
  /**
   * @generated from field: yatayat.booking.v1.TripOffer trip = 1;
   */
  trip?: TripOffer | undefined;

  /**
   * @generated from field: repeated yatayat.booking.v1.Seat seats = 2;
   */
  seats: Seat[];
};

/**
 * Describes the message yatayat.booking.v1.GetSeatMapResponse.
 * Use `create(GetSeatMapResponseSchema)` to create a new message.
 */
export const GetSeatMapResponseSchema: GenMessage<GetSeatMapResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 7);

/**
 * @generated from message yatayat.booking.v1.HoldSeatRequest
 */
export type HoldSeatRequest = Message<"yatayat.booking.v1.HoldSeatRequest"> & {
  /**
   * @generated from field: string trip_id = 1;
   */
  tripId: string;

  /**
   * @generated from field: string seat_no = 2;
   */
  seatNo: string;

  /**
   * @generated from field: string from_code = 3;
   */
  fromCode: string;

  /**
   * @generated from field: string to_code = 4;
   */
  toCode: string;
};

/**
 * Describes the message yatayat.booking.v1.HoldSeatRequest.
 * Use `create(HoldSeatRequestSchema)` to create a new message.
 */
export const HoldSeatRequestSchema: GenMessage<HoldSeatRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 8);

/**
 * @generated from message yatayat.booking.v1.HoldSeatResponse
 */
export type HoldSeatResponse = Message<"yatayat.booking.v1.HoldSeatResponse"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * Secret that proves the caller placed the hold; send it to confirm or release.
   *
   * @generated from field: string hold_token = 2;
   */
  holdToken: string;

  /**
   * @generated from field: int64 expires_at_ms = 3;
   */
  expiresAtMs: bigint;

  /**
   * @generated from field: yatayat.booking.v1.TripOffer trip = 4;
   */
  trip?: TripOffer | undefined;

  /**
   * @generated from field: string seat_no = 5;
   */
  seatNo: string;
};

/**
 * Describes the message yatayat.booking.v1.HoldSeatResponse.
 * Use `create(HoldSeatResponseSchema)` to create a new message.
 */
export const HoldSeatResponseSchema: GenMessage<HoldSeatResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 9);

/**
 * @generated from message yatayat.booking.v1.ReleaseHoldRequest
 */
export type ReleaseHoldRequest = Message<"yatayat.booking.v1.ReleaseHoldRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * @generated from field: string hold_token = 2;
   */
  holdToken: string;
};

/**
 * Describes the message yatayat.booking.v1.ReleaseHoldRequest.
 * Use `create(ReleaseHoldRequestSchema)` to create a new message.
 */
export const ReleaseHoldRequestSchema: GenMessage<ReleaseHoldRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 10);

/**
 * @generated from message yatayat.booking.v1.ReleaseHoldResponse
 */
export type ReleaseHoldResponse = Message<"yatayat.booking.v1.ReleaseHoldResponse"> & {
};

/**
 * Describes the message yatayat.booking.v1.ReleaseHoldResponse.
 * Use `create(ReleaseHoldResponseSchema)` to create a new message.
 */
export const ReleaseHoldResponseSchema: GenMessage<ReleaseHoldResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 11);

/**
 * @generated from message yatayat.booking.v1.ConfirmBookingRequest
 */
export type ConfirmBookingRequest = Message<"yatayat.booking.v1.ConfirmBookingRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * @generated from field: string hold_token = 2;
   */
  holdToken: string;

  /**
   * @generated from field: yatayat.booking.v1.PaymentMethod payment_method = 3;
   */
  paymentMethod: PaymentMethod;
};

/**
 * Describes the message yatayat.booking.v1.ConfirmBookingRequest.
 * Use `create(ConfirmBookingRequestSchema)` to create a new message.
 */
export const ConfirmBookingRequestSchema: GenMessage<ConfirmBookingRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 12);

/**
 * @generated from message yatayat.booking.v1.ConfirmBookingResponse
 */
export type ConfirmBookingResponse = Message<"yatayat.booking.v1.ConfirmBookingResponse"> & {
  /**
   * @generated from field: yatayat.booking.v1.Ticket ticket = 1;
   */
  ticket?: Ticket | undefined;
};

/**
 * Describes the message yatayat.booking.v1.ConfirmBookingResponse.
 * Use `create(ConfirmBookingResponseSchema)` to create a new message.
 */
export const ConfirmBookingResponseSchema: GenMessage<ConfirmBookingResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 13);

/**
 * @generated from message yatayat.booking.v1.ListMyTicketsRequest
 */
export type ListMyTicketsRequest = Message<"yatayat.booking.v1.ListMyTicketsRequest"> & {
};

/**
 * Describes the message yatayat.booking.v1.ListMyTicketsRequest.
 * Use `create(ListMyTicketsRequestSchema)` to create a new message.
 */
export const ListMyTicketsRequestSchema: GenMessage<ListMyTicketsRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 14);

/**
 * @generated from message yatayat.booking.v1.ListMyTicketsResponse
 */
export type ListMyTicketsResponse = Message<"yatayat.booking.v1.ListMyTicketsResponse"> & {
  /**
   * @generated from field: repeated yatayat.booking.v1.Ticket tickets = 1;
   */
  tickets: Ticket[];
};

/**
 * Describes the message yatayat.booking.v1.ListMyTicketsResponse.
 * Use `create(ListMyTicketsResponseSchema)` to create a new message.
 */
export const ListMyTicketsResponseSchema: GenMessage<ListMyTicketsResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 15);

/**
 * @generated from message yatayat.booking.v1.GetTicketRequest
 */
export type GetTicketRequest = Message<"yatayat.booking.v1.GetTicketRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message yatayat.booking.v1.GetTicketRequest.
 * Use `create(GetTicketRequestSchema)` to create a new message.
 */
export const GetTicketRequestSchema: GenMessage<GetTicketRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 16);

/**
 * @generated from message yatayat.booking.v1.GetTicketResponse
 */
export type GetTicketResponse = Message<"yatayat.booking.v1.GetTicketResponse"> & {
  /**
   * @generated from field: yatayat.booking.v1.Ticket ticket = 1;
   */
  ticket?: Ticket | undefined;
};

/**
 * Describes the message yatayat.booking.v1.GetTicketResponse.
 * Use `create(GetTicketResponseSchema)` to create a new message.
 */
export const GetTicketResponseSchema: GenMessage<GetTicketResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 17);

/**
 * @generated from message yatayat.booking.v1.CancelTicketRequest
 */
export type CancelTicketRequest = Message<"yatayat.booking.v1.CancelTicketRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message yatayat.booking.v1.CancelTicketRequest.
 * Use `create(CancelTicketRequestSchema)` to create a new message.
 */
export const CancelTicketRequestSchema: GenMessage<CancelTicketRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 18);

/**
 * @generated from message yatayat.booking.v1.CancelTicketResponse
 */
export type CancelTicketResponse = Message<"yatayat.booking.v1.CancelTicketResponse"> & {
  /**
   * @generated from field: yatayat.booking.v1.Ticket ticket = 1;
   */
  ticket?: Ticket | undefined;
};

/**
 * Describes the message yatayat.booking.v1.CancelTicketResponse.
 * Use `create(CancelTicketResponseSchema)` to create a new message.
 */
export const CancelTicketResponseSchema: GenMessage<CancelTicketResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 19);

/**
 * @generated from message yatayat.booking.v1.VerifyTicketRequest
 */
export type VerifyTicketRequest = Message<"yatayat.booking.v1.VerifyTicketRequest"> & {
  /**
   * @generated from field: string qr_payload = 1;
   */
  qrPayload: string;
};

/**
 * Describes the message yatayat.booking.v1.VerifyTicketRequest.
 * Use `create(VerifyTicketRequestSchema)` to create a new message.
 */
export const VerifyTicketRequestSchema: GenMessage<VerifyTicketRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 20);

/**
 * @generated from message yatayat.booking.v1.VerifyTicketResponse
 */
export type VerifyTicketResponse = Message<"yatayat.booking.v1.VerifyTicketResponse"> & {
  /**
   * @generated from field: yatayat.booking.v1.VerificationResult result = 1;
   */
  result: VerificationResult;

  /**
   * @generated from field: string ticket_code = 2;
   */
  ticketCode: string;

  /**
   * @generated from field: string trip_id = 3;
   */
  tripId: string;

  /**
   * @generated from field: string seat_no = 4;
   */
  seatNo: string;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef from = 5;
   */
  from?: PlaceRef | undefined;

  /**
   * @generated from field: yatayat.network.v1.PlaceRef to = 6;
   */
  to?: PlaceRef | undefined;
};

/**
 * Describes the message yatayat.booking.v1.VerifyTicketResponse.
 * Use `create(VerifyTicketResponseSchema)` to create a new message.
 */
export const VerifyTicketResponseSchema: GenMessage<VerifyTicketResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 21);

/**
 * @generated from message yatayat.booking.v1.TicketKey
 */
export type TicketKey = Message<"yatayat.booking.v1.TicketKey"> & {
  /**
   * @generated from field: string key_id = 1;
   */
  keyId: string;

  /**
   * Ed25519 public key.
   *
   * @generated from field: bytes public_key = 2;
   */
  publicKey: Uint8Array;
};

/**
 * Describes the message yatayat.booking.v1.TicketKey.
 * Use `create(TicketKeySchema)` to create a new message.
 */
export const TicketKeySchema: GenMessage<TicketKey> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 22);

/**
 * @generated from message yatayat.booking.v1.ListTicketKeysRequest
 */
export type ListTicketKeysRequest = Message<"yatayat.booking.v1.ListTicketKeysRequest"> & {
};

/**
 * Describes the message yatayat.booking.v1.ListTicketKeysRequest.
 * Use `create(ListTicketKeysRequestSchema)` to create a new message.
 */
export const ListTicketKeysRequestSchema: GenMessage<ListTicketKeysRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 23);

/**
 * @generated from message yatayat.booking.v1.ListTicketKeysResponse
 */
export type ListTicketKeysResponse = Message<"yatayat.booking.v1.ListTicketKeysResponse"> & {
  /**
   * @generated from field: repeated yatayat.booking.v1.TicketKey keys = 1;
   */
  keys: TicketKey[];
};

/**
 * Describes the message yatayat.booking.v1.ListTicketKeysResponse.
 * Use `create(ListTicketKeysResponseSchema)` to create a new message.
 */
export const ListTicketKeysResponseSchema: GenMessage<ListTicketKeysResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_booking_v1_booking, 24);

/**
 * @generated from enum yatayat.booking.v1.TicketStatus
 */
export enum TicketStatus {
  /**
   * @generated from enum value: TICKET_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TICKET_STATUS_HELD = 1;
   */
  HELD = 1,

  /**
   * @generated from enum value: TICKET_STATUS_CONFIRMED = 2;
   */
  CONFIRMED = 2,

  /**
   * @generated from enum value: TICKET_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: TICKET_STATUS_EXPIRED = 4;
   */
  EXPIRED = 4,

  /**
   * @generated from enum value: TICKET_STATUS_RELEASED = 5;
   */
  RELEASED = 5,
}

/**
 * Describes the enum yatayat.booking.v1.TicketStatus.
 */
export const TicketStatusSchema: GenEnum<TicketStatus> = /*@__PURE__*/
  enumDesc(file_yatayat_booking_v1_booking, 0);

/**
 * @generated from enum yatayat.booking.v1.Channel
 */
export enum Channel {
  /**
   * @generated from enum value: CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANNEL_WEB = 1;
   */
  WEB = 1,

  /**
   * @generated from enum value: CHANNEL_COUNTER = 2;
   */
  COUNTER = 2,

  /**
   * @generated from enum value: CHANNEL_PARTNER = 3;
   */
  PARTNER = 3,
}

/**
 * Describes the enum yatayat.booking.v1.Channel.
 */
export const ChannelSchema: GenEnum<Channel> = /*@__PURE__*/
  enumDesc(file_yatayat_booking_v1_booking, 1);

/**
 * @generated from enum yatayat.booking.v1.PaymentMethod
 */
export enum PaymentMethod {
  /**
   * @generated from enum value: PAYMENT_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_METHOD_WALLET = 1;
   */
  WALLET = 1,

  /**
   * @generated from enum value: PAYMENT_METHOD_QR = 2;
   */
  QR = 2,

  /**
   * @generated from enum value: PAYMENT_METHOD_BANK = 3;
   */
  BANK = 3,

  /**
   * Counter sales only.
   *
   * @generated from enum value: PAYMENT_METHOD_CASH = 4;
   */
  CASH = 4,
}

/**
 * Describes the enum yatayat.booking.v1.PaymentMethod.
 */
export const PaymentMethodSchema: GenEnum<PaymentMethod> = /*@__PURE__*/
  enumDesc(file_yatayat_booking_v1_booking, 2);

/**
 * @generated from enum yatayat.booking.v1.VerificationResult
 */
export enum VerificationResult {
  /**
   * @generated from enum value: VERIFICATION_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERIFICATION_RESULT_VALID = 1;
   */
  VALID = 1,

  /**
   * The payload can't be read.
   *
   * @generated from enum value: VERIFICATION_RESULT_MALFORMED = 2;
   */
  MALFORMED = 2,

  /**
   * The signing key is unknown.
   *
   * @generated from enum value: VERIFICATION_RESULT_UNKNOWN_KEY = 3;
   */
  UNKNOWN_KEY = 3,

  /**
   * The signature doesn't match: forged or altered.
   *
   * @generated from enum value: VERIFICATION_RESULT_BAD_SIGNATURE = 4;
   */
  BAD_SIGNATURE = 4,

  /**
   * Genuine, but the ticket was cancelled.
   *
   * @generated from enum value: VERIFICATION_RESULT_CANCELLED = 5;
   */
  CANCELLED = 5,
}

/**
 * Describes the enum yatayat.booking.v1.VerificationResult.
 */
export const VerificationResultSchema: GenEnum<VerificationResult> = /*@__PURE__*/
  enumDesc(file_yatayat_booking_v1_booking, 3);

/**
 * BookingService sells seats on trips: search, seat maps, holds, confirmation and
 * cancellation. One seat ledger serves every channel (ADR-0004, ADR-0008, ADR-0009).
 *
 * @generated from service yatayat.booking.v1.BookingService
 */
export const BookingService: GenService<{
  /**
   * SearchTrips lists the day's sellable trips that stop at from_code before to_code,
   * each priced for that stretch.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.SearchTrips
   */
  searchTrips: {
    methodKind: "unary";
    input: typeof SearchTripsRequestSchema;
    output: typeof SearchTripsResponseSchema;
  },
  /**
   * GetSeatMap returns a trip's seats and which are free, priced for a stretch.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.GetSeatMap
   */
  getSeatMap: {
    methodKind: "unary";
    input: typeof GetSeatMapRequestSchema;
    output: typeof GetSeatMapResponseSchema;
  },
  /**
   * HoldSeat reserves a seat for ten minutes while the buyer signs in and pays.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.HoldSeat
   */
  holdSeat: {
    methodKind: "unary";
    input: typeof HoldSeatRequestSchema;
    output: typeof HoldSeatResponseSchema;
  },
  /**
   * ReleaseHold gives a held seat back before the hold expires.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.ReleaseHold
   */
  releaseHold: {
    methodKind: "unary";
    input: typeof ReleaseHoldRequestSchema;
    output: typeof ReleaseHoldResponseSchema;
  },
  /**
   * ConfirmBooking takes payment for a held seat and issues the signed ticket.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.ConfirmBooking
   */
  confirmBooking: {
    methodKind: "unary";
    input: typeof ConfirmBookingRequestSchema;
    output: typeof ConfirmBookingResponseSchema;
  },
  /**
   * ListMyTickets lists the signed-in passenger's tickets, newest first.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.ListMyTickets
   */
  listMyTickets: {
    methodKind: "unary";
    input: typeof ListMyTicketsRequestSchema;
    output: typeof ListMyTicketsResponseSchema;
  },
  /**
   * GetTicket returns one of the signed-in passenger's tickets.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.GetTicket
   */
  getTicket: {
    methodKind: "unary";
    input: typeof GetTicketRequestSchema;
    output: typeof GetTicketResponseSchema;
  },
  /**
   * CancelTicket cancels a confirmed ticket under DoTM's cancellation caps and refunds the rest.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.CancelTicket
   */
  cancelTicket: {
    methodKind: "unary";
    input: typeof CancelTicketRequestSchema;
    output: typeof CancelTicketResponseSchema;
  },
  /**
   * VerifyTicket checks a scanned QR payload online: signature, and that the ticket is still valid.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.VerifyTicket
   */
  verifyTicket: {
    methodKind: "unary";
    input: typeof VerifyTicketRequestSchema;
    output: typeof VerifyTicketResponseSchema;
  },
  /**
   * ListTicketKeys returns the public keys that sign tickets, for offline checks.
   *
   * @generated from rpc yatayat.booking.v1.BookingService.ListTicketKeys
   */
  listTicketKeys: {
    methodKind: "unary";
    input: typeof ListTicketKeysRequestSchema;
    output: typeof ListTicketKeysResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yatayat_booking_v1_booking, 0);

